<div id="case-accident-description" class="container-fluid pb-3">
    <mat-card>

        <mat-card-content *ngIf="case">
            <div class="row no-gutters">
                <!-- START COLUMN 1 -->
                <div class="col-sm-4">
                    <div class="row no-gutters">
                        <div class="col-sm-10">
                            <mat-card>
                                <mat-card-title>{{ 'detailed_processing.accident_description.title.accident_location' | translate }}</mat-card-title>

                                <mat-card-content>
                                    <address-participant #addressAccidentLocation
                                                         [idPrefix]="(idPrefix + 'vehicle_location.')"
                                                         [type]="addressParticipantType"
                                                         [config]="addressParticipantOptions"
                                                         [disabled]="false">
                                    </address-participant>
                                </mat-card-content>

                            </mat-card>
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                    </div>
                </div>
                <!-- END COLUMN 1 -->

                <!-- START COLUMN 2 -->
                <div class="col-sm-4" style="margin-top: 12px;">

                    <div class="row no-gutters">
                        <div class="col-sm-10">
                            <date-time-picker [idPrefix]="(idPrefix + 'claim_date.')"
                                              [date]="case.claim_date"
                                              [time]="case.claim_date_usertime"
                                              [options]="claimDateTimePickerOptions"
                                              [disabled]="disabled"
                                              (multiUpdated)="patchOpDataArray($event)">
                            </date-time-picker>
                        </div>
                        <div class="col-sm-2">
                            <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                        </div>
                    </div>

                    <div class="row no-gutters">
                        <div class="col-sm-10">
                            <mat-form-field class="full-width">
                                <mat-label>{{ case.accident.trans.police_department | translate }}</mat-label>
                                <input id="{{idPrefix}}{{case.accident.trans.police_department}}"
                                       type="text" matInput
                                       [(ngModel)]="case.accident.police_department"
                                       (blur)="patchAndUpdate('accident.police_department')"
                                       [disabled]="disabled">
                            </mat-form-field>
                        </div>
                        <div class="col-sm-2">
                            <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                        </div>
                    </div>

                    <div class="row no-gutters">
                        <div class="col-sm-10">
                            <mat-form-field class="full-width">
                                <mat-label>{{ case.accident.trans.police_reference_number | translate }}</mat-label>
                                <input id="{{idPrefix}}{{case.accident.trans.police_reference_number}}"
                                       type="text" matInput
                                       [(ngModel)]="case.accident.police_reference_number"
                                       (blur)="patchAndUpdate('accident.police_reference_number')"
                                       [disabled]="disabled">
                            </mat-form-field>
                        </div>
                        <div class="col-sm-2">
                            <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                        </div>
                    </div>

                    <div class="row no-gutters">
                        <div class="col-sm-10">
                            <mat-form-field class="full-width">
                                <mat-label>{{ case.accident.trans.clerk | translate }}</mat-label>
                                <input id="{{idPrefix}}{{case.accident.trans.clerk}}"
                                       type="text" matInput
                                       [(ngModel)]="case.accident.clerk"
                                       (blur)="patchAndUpdate('accident.clerk')"
                                       [disabled]="disabled">
                            </mat-form-field>
                        </div>
                        <div class="col-sm-2">
                            <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                        </div>
                    </div>

                    <div class="row no-gutters">
                        <div class="col-sm-10">
                            <mat-form-field class="full-width">
                                <mat-label>{{ case.accident.trans.comment | translate }}</mat-label>
                                <textarea id="{{idPrefix}}{{case.accident.trans.comment}}"
                                          matInput
                                          rows="8"
                                          [(ngModel)]="case.accident.comment"
                                          (blur)="patchAndUpdate('accident.comment')"
                                          [disabled]="disabled">
                                </textarea>
                            </mat-form-field>
                        </div>
                        <div class="col-sm-2">
                            <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                        </div>
                    </div>

                </div>
                <!-- END COLUMN 2 -->

                <!-- START COLUMN 3 -->
                <div class="col-sm-4">
                    <case-files-upload class="full-width"
                                       [idPrefix]="idPrefix"
                                       *ngIf="case && fileMetaCategoryList"
                                       [caseId]="case.id"
                                       [(fileMetaCategoryList)]="fileMetaCategoryList"
                                       [smpFileCategory]="accidentDocumentCategory"
                                       [dropzoneLabel]="'detailed_processing.accident_description.label.upload_attachment_document' | translate"
                                       [addButtonLabel]="'common.btn.add_attachment' | translate"
                                       [acceptedFiles]="acceptedFileTypes"
                                       [hasContent]="fileMetaCategoryList?.getFilesByCategory(accidentDocumentCategory)?.entries.length > 0">

                        <!-- only works with a dropzone. List is displayed inside the dropzone (if it has files) -->
                        <case-files-list class="full-width"
                                         [idPrefix]="idPrefix"
                                         [caseId]="case.id"
                                         [(fileMetaCategoryList)]="fileMetaCategoryList"
                                         [smpFileCategory]="accidentDocumentCategory">
                        </case-files-list>

                    </case-files-upload>

                </div>
                <!-- END COLUMN 3 -->

            </div>
            <!-- END ROW 1 -->


            <!-- START ROW 2 -->
            <div class="row no-gutters" style="margin-top: 25px;">
                <div class="col-sm-12">
                    <div class="row no-gutters">
                        <div class="col-xl col-lg-2 col-md-3 col-sm-4 dr-checkbox-container"
                             *ngFor="let type of damageTypes; let i = index;"
                             [ngClass]="{'first-checkbox': i === 0, 'last-checkbox': i === (damageTypes.length - 1)}">
                            <dr-checkbox [idPrefix]="idPrefix"
                                         [idSuffix]="case.accident.trans[type]"
                                         [boolValue]="case.accident[type]"
                                         [label]="case.accident.trans[type]"
                                         [patchPath]="'accident.' + type"
                                         (updated)="patchAndUpdateWithValue($event)">
                            </dr-checkbox>
                        </div>
                    </div>
                </div>
            </div>
            <!-- END ROW 2 -->

            <!-- START ROW 3 -->
            <div class="row no-gutters" style="margin-top: 25px; margin-bottom: 25px;">
                <div class="col-sm-12">
                    <mat-form-field class="full-width">
                        <mat-label>{{ case.accident.trans.description | translate }}</mat-label>
                        <textarea id="{{idPrefix}}{{case.accident.trans.description}}"
                                  matInput
                                  rows="8"
                                  [(ngModel)]="case.accident.description"
                                  (blur)="patchAndUpdate('accident.description')"
                                  [disabled]="disabled">
                        </textarea>
                    </mat-form-field>
                </div>
            </div>
            <!-- END ROW 3 -->

            <!-- START ROW 3 -->
            <mat-card-title>{{ 'detailed_processing.accident_description.title.claim_images' | translate }}</mat-card-title>

            <div class="row no-gutters" style="margin-top: 25px;">
                <case-files-upload class="full-width"
                                   [idPrefix]="idPrefix"
                                   *ngIf="case && fileMetaCategoryList"
                                   [caseId]="case.id"
                                   [(fileMetaCategoryList)]="fileMetaCategoryList"
                                   [smpFileCategory]="claimImageCategory"
                                   [dropzoneLabel]="'detailed_processing.accident_description.label.upload_claim_images' | translate"
                                   [addButtonLabel]="'common.btn.add_claim_images' | translate"
                                   [acceptedFiles]="acceptedFileTypes"
                                   [hasContent]="fileMetaCategoryList?.getFilesByCategory(claimImageCategory)?.entries.length > 0">

                    <!-- only works with a dropzone. List is displayed inside the dropzone (if it has files) -->
                    <case-files-thumbnails-list class="full-width"
                                                [idPrefix]="idPrefix"
                                                [caseId]="case.id"
                                                [(fileMetaCategoryList)]="fileMetaCategoryList"
                                                [smpFileCategory]="claimImageCategory"
                                                [labelProp]="'whoAndWhen'">
                    </case-files-thumbnails-list>

                </case-files-upload>
            </div>

            <!-- START ROW 4 -->
            <!-- Empty mat-card-title so we simply get the same blue line as the title -->
            <mat-card-title class="mt-5 mb-5"></mat-card-title>

            <div class="row no-gutters" style="margin-top: 25px;">

                <div class="col-sm-12">
                    <damage-area-selector [idPrefix]="idPrefix"
                                          [case]="case"
                                          (updated)="patchAndUpdateWithValue($event)"
                                          (multiUpdated)="patchOpDataArray($event)">
                    </damage-area-selector>
                </div>

            </div>

        </mat-card-content>
    </mat-card>
</div>
